import { render, staticRenderFns } from "./CallBox.vue?vue&type=template&id=f62f5124&scoped=true"
import script from "./CallBox.vue?vue&type=script&lang=js"
export * from "./CallBox.vue?vue&type=script&lang=js"
import style0 from "./CallBox.vue?vue&type=style&index=0&id=f62f5124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62f5124",
  null
  
)

export default component.exports